import { Search as SearchIcon } from "@mui/icons-material";
import { InputAdornment, type SxProps, TextField, type TextFieldProps, type Theme } from "@mui/material";

const defaultSx: SxProps<Theme> = { maxWidth: { lg: 480, xs: "100%" } };

export interface EntityListSearchFieldProps {
  autoComplete?: "off" | "on";
  id: string;
  label: string;
  onChange: TextFieldProps["onChange"];
  size?: "small" | "medium";
  /** Merged with default `maxWidth` (480px on `lg+`, full width on `xs`). */
  sx?: SxProps<Theme>;
  value: string;
}

export const EntityListSearchField = ({
  autoComplete = "off",
  label,
  id,
  onChange,
  value,
  size = "small",
  sx,
}: EntityListSearchFieldProps) => {
  return (
    <TextField
      fullWidth
      autoComplete={autoComplete}
      id={id}
      label={label}
      value={value}
      size={size}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
      sx={[defaultSx, ...(sx == null ? [] : [sx])] as SxProps<Theme>}
      onChange={onChange}
    />
  );
};
